export default class CustomAdapter {
    constructor(loader, url){
        this.xhr = null;
        this.loader = loader;
        this.url = url;
    }

    upload(){
        return this.loader.file.then(file => new Promise(
            (resolve, reject) => {
                this._initRequest();
                this._initListeners( resolve, reject, file );
                this._sendRequest( file );
            }
        ));
    }

    abort(){
        if(this.xhr){
            this.xhr.abort();
        }
    }

    _initRequest(){
        const xhr = this.xhr = new XMLHttpRequest();
        xhr.open('POST', this.url, true);
        xhr.responseType = 'json';
    }

    _initListeners(resolve, reject, file){
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = 'Nie można wgrać pliku: ' + file.name;

        xhr.addEventListener('error', () => reject(genericErrorText));
        xhr.addEventListener('abort', () => reject());
        xhr.addEventListener('load', () => {
            const response = xhr.response;

            if(!response || response.error){
                return reject(response && response.error ? response.error : genericErrorText);
            }
			
			let asset = JSON.parse(JSON.stringify(response.data));
			asset.file = asset.default;
			delete asset.dafault;
			Browser.getInstance().addData(asset);
            
            resolve(response.data); //Response data contains {id: ..., default: ..., datetime: ...}
        } );

        if(xhr.upload){
            xhr.upload.addEventListener('progress', evt => {
                if(evt.lengthComputable){
                    loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                }
            });
        }
    }

    _sendRequest(file){
        const data = new FormData();
        data.append('image', file);
        this.xhr.send(data);
    }
}